import $ from '~/qwery';
import bean from '~/bean';
import Button from '~/components/button';
import Popup from '~/components/popup/popup';
import popupManager from '~/components/popup/manager';

export default class PhotoPopup extends Popup {
    constructor(pageHeading, itemName, photos, i, options) {
        super({noInit: true});
        this._photos = photos;
        this._i = i;
        this.init(Object.assign({
            class: 'photo-popup',
            title: pageHeading,
            content:
                '<div class="b-photo-popup-content hidden">'
                    + '<span class="'
                        + 'prev-button'
                        + ' <% if (photos.length == 1) { %>'
                            + 'disabled'
                        + '<% } %>'
                    + '"><span class="arrow">&lang;</span></span>'
                    + '<span class="'
                        + 'next-button'
                        + ' <% if (photos.length == 1) { %>'
                            + 'disabled'
                        + '<% } %>'
                    + '"><span class="arrow">&rang;</span></span>'
                    + '<table class="center-table"><tr><td class="center-table-cell">'
                        + '<img src="<%= photos[i]["file.url"] %>"'
                        + ' alt="<%= itemName %>">'
                    + '</table>'
                + '</div>',
            templateVars: {itemName, photos, i},
            afterRenderTemplate: () => {
                this.$content = $('.b-photo-popup-content', this.$el);
                this.$prevButton = $('.prev-button', this.$content);
                this.$prevButtonArrow = $('.arrow', this.$prevButton);
                this.$nextButton = $('.next-button', this.$content);
                this.$nextButtonArrow = $('.arrow', this.$nextButton);
                this.$centerTableCell = $('.center-table-cell', this.$content);
                this.$img = $('img', this.$content);
            },
            beforeWaitForImages: () => {
                this.updateMaxImageExtents();
                this.$content.removeClass('hidden');
            },
            afterShow: () => {
                if (this._photos.length == 1) {
                    this._header._closeButton.focus();
                } else
                    this.$nextButtonArrow[0].focus();
            },
        }, options));
        if (this._photos.length > 1) {
            new Button(this.$prevButtonArrow);
            new Button(this.$nextButtonArrow);
        }
        const getInitialEvent = e => e.detail.initialEvent || e;
        const onPrevButtonPress = e => {
            if (getInitialEvent(e).originalEvent.prevButtonPressHandled) return;
            popupManager.markEnterAsHandled(getInitialEvent(e));
            this._i = this._i ? this._i - 1 : this._photos.length - 1;
            this._showImg();
            getInitialEvent(e).originalEvent.prevButtonPressHandled = true;
        };
        const onNextButtonPress = e => {
            if (getInitialEvent(e).originalEvent.nextButtonPressHandled) return;
            popupManager.markEnterAsHandled(getInitialEvent(e));
            this._i = (this._i + 1) % this._photos.length;
            this._showImg();
            getInitialEvent(e).originalEvent.nextButtonPressHandled = true;
        };
        bean.on(this.$prevButton[0], 'click', onPrevButtonPress);
        bean.on(this.$prevButtonArrow[0], 'press', onPrevButtonPress);
        bean.on(this.$nextButton[0], 'click', onNextButtonPress);
        bean.on(this.$nextButtonArrow[0], 'press', onNextButtonPress);
    }

    _showImg() {
        this.$img.attr('src', this._photos[this._i]['file.url']);
    }

    updateExtents(event) {
        if (event == 'windowResize')
            this.updateMaxImageExtents();
        super.updateExtents(event);
    }

    updateMaxImageExtents() {
        const maxContentWidth = this.maxContentWidth() < 100
            ? 100 : this.maxContentWidth();
        const maxContentHeight = this.maxContentHeight() < 100
            ? 100 : this.maxContentHeight();
        const [maxImgWidth, maxImgHeight] = this._photos.reduce((r, i) => {
            const [w, h] = i['width'] > maxContentWidth
                || i['height'] > maxContentHeight
                ? i['width'] / i['height'] > maxContentWidth / maxContentHeight
                    ? [
                        maxContentWidth,
                        i['height'] * maxContentWidth / i['width'],
                    ] : [
                        i['width'] * maxContentHeight / i['height'],
                        maxContentHeight,
                    ]
                : [i['width'], i['height']];
            r[0] = Math.max(r[0], w);
            r[1] = Math.max(r[1], h);
            return r;
        }, [0, 0]);
        $('img', this.$content).css('max-width', maxImgWidth + 'px');
        $('img', this.$content).css('max-height', maxImgHeight + 'px');
        this.$centerTableCell.css('width', maxImgWidth + 'px');
        this.$centerTableCell.css('height', maxImgHeight + 'px');
    }

    maxContentWidth() {
        return super.maxContentWidth()
            - parseFloat(this.$content.css('padding-left'))
            - parseFloat(this.$content.css('padding-right'));
    }

    maxContentHeight() {
        return super.maxContentHeight()
            - parseFloat(this.$content.css('padding-top'))
            - parseFloat(this.$content.css('padding-bottom'));
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/photo-popup.js